import React from 'react';
import { Field, Control, Column, Button } from "rbx";
import { Link } from "react-router-dom";

const ActionButtons = (props) => {
  const { linkName, handleClickBack, buttonState, buttonName } = props;

  return (
    <Field>
      <Control>
        <Column.Group breakpoint="mobile">
          <Column className="has-text-left">
            <Link onClick={handleClickBack} className="button is-danger">{linkName}</Link>
          </Column>
          <Column className="has-text-right">
            <Button state={buttonState} color="custom-purple" outlined>{buttonName}</Button>
          </Column>
        </Column.Group>
      </Control>
    </Field>
  )

}

export default ActionButtons;
